export default __webpack_public_path__ + "static/media/footer_image_1.dcb789b7.jpg";